import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { PageEvent } from "@angular/material/paginator";
import { Observable, Subscription, of } from "rxjs";
import { ObservationService } from "../service/observation.service";
import { MatDialog } from "@angular/material/dialog";
import { DialogFilterComponent } from "../../widget/dialog-filter/dialog-filter.component";
import { map, startWith } from "rxjs/operators";
import { VariedadService } from "../../variedad/service/variedad.service";
import { AuthService } from "../../auth/service/auth.service";
import { RespCountriesObservation, RespRegionsObservation } from "../model/observation.model";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { APP_DATE_FORMATS, AppDateAdapter } from "../../widget/date-picker/date-picker.component";
import { GuardianService } from "../../guardian/service/guardian.service";
import { Router } from "@angular/router";
import { UserService } from "../../user/service/user.service";


export interface Coordinates {
  latitude: number;
  longitude: number;
  location: string;
}
export interface DialogData {
  formAnyDate: boolean;
  formDate: any | null;
  formDateInit: any | null;
  formDateEnd: any | null;
  formSelected: string | null;
  formPersonId: number | null;
  formPersonValue: string | null;
  formSite: string | null;
}
@Component({
  selector: "app-observation-list-edit",
  templateUrl: "./observation-list-edit.component.html",
  styleUrls: ["./observation-list-edit.component.css"],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ],
})
export class ObservationListEditComponent implements OnInit {

  // NORMAL FILTERS part.1
  @Input() p_variety_name!: any | null;
  @Input() p_farmer_name!: any | null;

  // ADVANCE FILTER
  @Input() p_any_date!: any | null;
  @Input() p_date_exactly!: any | null;
  @Input() p_date_init!: any | null;
  @Input() p_date_end!: any | null;
  @Input() p_month!: any | null;
  @Input() p_user_id!: any | null;
  @Input() p_username!: any | null;
  @Input() p_place!: any | null;

  // NORMAL FILTERS part.2
  @Input() p_country!: any | null;
  @Input() p_is_original!: any | null;
  @Input() p_is_public!: any | null;

  constructor(
    private observationService: ObservationService,
    public dialog: MatDialog,
    private variedadService: VariedadService,
    private guardianService: GuardianService,
    private authService: AuthService,
    public router: Router,
    public userService: UserService,
  ) { }

  filteredOptionsVariety!: Observable<string[]>;
  filteredOptionsFarmer!: Observable<string[]>;
  filteredOptionsCountry!: Observable<RespCountriesObservation>;
  statsObs!: Observable<any>;

  badgeFilter: number | null = null;
  cardContentList!: any[];
  gpsCoordinateList!: any[];
  _showFirstLastButtons = true;
  _pageSizeOptions: number[] = [5, 20, 40, 60, 100, 500];
  page_control = 0;
  page_size_control = 5;
  _length = 100;
  varietyObservationSubs$!: Subscription;
  variety_control = new FormControl();

  farmer_control = new FormControl();
  farmer_id_control = new FormControl();

  province_control = new FormControl();
  district_control = new FormControl();
  locality_control = new FormControl();

  observation_date_control = new FormControl();
  observation_date_start_control = new FormControl();
  observation_date_end_control = new FormControl();
  observation_date_months = new FormControl();

  varietal_group_value = 'Todos';
  country_value = null;
  is_original_value = null;
  is_public_value = null;

  paramsData = {
    p_variety_name: null,
    p_farmer_name: null,
    p_any_date: true,
    p_date_exactly: null,
    p_date_init: null,
    p_date_end: null,
    p_month: null,
    p_user_id: null,
    p_username: null,
    p_place: null,

    p_country: 'Todos',
    p_is_original: 'Todos',
    p_is_public: 'Todos',
  };

  ngOnInit(): void {
    this.filteredOptionsVariety = this.variety_control.valueChanges.pipe(
      startWith(""),
      map((_value) => this.fnSearchVarietyNames(_value))
    );

    this.filteredOptionsFarmer = this.farmer_control.valueChanges.pipe(
      startWith(""),
      map((_value) => this.fnSearchFarmerNames(_value))
    );

    this.filteredOptionsCountry = this.observationService.getCountries();

    this.fnSearchVarietyObservation("ngOnInit");

    this.fnLoadFilter();
  }

  fnSearchVarietyObservation(_from: string | null = null) {

    const _var = {
      page: this.page_control,
      page_size: this.page_size_control,
      variety_name: this.p_variety_name,


      country: this.p_country === 'Todos' ? null : this.p_country,

      region: null,
      farmer_name: this.p_farmer_name,
      province: this.province_control.value,
      district: this.district_control.value,
      locality: this.locality_control.value,
      observation_date: this.p_date_exactly,
      // this.observation_date_control.value ? this.observation_date_control.value.toISOString().slice(0, 10) : null,
      observation_date_start: this.p_date_init,
      // this.observation_date_start_control.value ? this.observation_date_start_control.value.toISOString().slice(0, 10) : null,
      observation_date_end: this.p_date_end,
      //  this.observation_date_end_control.value ? this.observation_date_end_control.value.toISOString().slice(0, 10) : null,
      user_id: this.p_user_id,

      varietal_group: this.varietal_group_value === 'Todos' ? null : this.varietal_group_value,
      farmer_id: this.farmer_id_control.value,

      is_original: this.p_is_original === 'Todos' ? null : (this.p_is_original === 'Si' ? true : false),
      is_public: this.p_is_public === 'Todos' ? null : (this.p_is_public === 'Si' ? true : false),

      months: this.observation_date_months.value ? this.observation_date_months.value : null,
      sort_by: 'modified_date',
    };

    console.log({ _var: _var });

    this.cardContentList = [];
    this.gpsCoordinateList = [];
    const _gpsCoordinateList: any[] = [];
    this.varietyObservationSubs$ = this.observationService
      .getSearch(_var)
      .subscribe((_resp: any) => {

        this._length = _resp.pagination.total_count;

        _resp.data.map((_element: any) => {
          const _coordinate = {
            latitude: _element.latitude,
            longitude: _element.longitude,
            location: _element.location,
          };
          const _prod = _coordinate.latitude * _coordinate.longitude;
          if (_prod != 0) {
            _gpsCoordinateList.push(_coordinate);
          }


          this.cardContentList.push({
            card_id: _element.variety_observation_id,
            card_id_1: _element.variety_id,
            card_name: _element.variety_name,
            card_id_2: _element.species_id,
            card_name_2: _element.species_name,
            card_value_1: _element.synonyms,
            card_date: _element.observation_date,
            card_value_2: _element.location,
            card_user_id: _element.user_id,
            card_username: _element.username,
            card_user_image_url: _element.user_image_url,
            card_image_url: _element.observation_image_url,
            flag_1: _element.is_public,
          });
        });
      });

    this.gpsCoordinateList = _gpsCoordinateList;
  }


  fnLoadFilter() {

    // NORMAL FILTER
    if (this.p_variety_name) {
      this.paramsData.p_variety_name = this.p_variety_name;
      this.variety_control.setValue(this.p_variety_name);
    }

    if (this.p_farmer_name) {
      this.paramsData.p_farmer_name = this.p_farmer_name;
      this.farmer_control.setValue(this.p_farmer_name);
    }

    if (this.p_country) {
      this.paramsData.p_country = this.p_country;
      this.country_value = this.p_country;
    }

    if (this.p_is_original) {
      this.paramsData.p_is_original = this.p_is_original;
      this.is_original_value = this.p_is_original;
    }
    if (this.p_is_public) {
      this.paramsData.p_is_public = this.p_is_public;
      this.is_public_value = this.p_is_public;
    }


    // BI FILTER
    if (this.p_date_exactly) {
      this.paramsData.p_date_exactly = this.p_date_exactly;
      this.badgeFilter = this.badgeFilter ? this.badgeFilter + 1 : 1;

      this.observation_date_control.setValue(this.p_date_exactly);
    }

    // ADVANCE FILTER
    if (this.p_user_id) {
      this.userService.getUserById(this.p_user_id).subscribe(
        (x) => {
          this.paramsData.p_username = x.data.username;
          this.paramsData.p_user_id = this.p_user_id;
          this.badgeFilter = this.badgeFilter ? this.badgeFilter + 1 : 1;
        }
      );
    }

    if (this.p_date_init) {
      this.paramsData.p_date_init = this.p_date_init;
      this.badgeFilter = this.badgeFilter ? this.badgeFilter + 1 : 1;
    }

    if (this.p_date_end) {
      this.paramsData.p_date_end = this.p_date_end;
      this.badgeFilter = this.badgeFilter ? this.badgeFilter + 1 : 1;
    }

    if (this.p_month) {
      this.paramsData.p_month = this.p_month;
      this.badgeFilter = this.badgeFilter ? this.badgeFilter + 1 : 1;
    }

  }

  fnParamsDataChange(_paramsData: any, _param: string | null = null) {
    const _cParamsData = this.paramsData;
    if (_param == 'p_variety_name') {
      _cParamsData.p_variety_name = _paramsData.p_variety_name;
      this.fnGoToView('/tablero/explorer-list-edit', _cParamsData)
    }
    else if (_param == 'p_farmer_name') {
      _cParamsData.p_farmer_name = _paramsData.p_farmer_name;
      this.fnGoToView('/tablero/explorer-list-edit', _cParamsData)
    }
    else if (_param == 'p_country') {
      _cParamsData.p_country = _paramsData.p_country;
      this.fnGoToView('/tablero/explorer-list-edit', _cParamsData)
    }
    else if (_param == 'p_is_original') {
      _cParamsData.p_is_original = _paramsData.p_is_original;
      this.fnGoToView('/tablero/explorer-list-edit', _cParamsData)
    }
    else if (_param == 'p_is_public') {
      _cParamsData.p_is_public = _paramsData.p_is_public;
      this.fnGoToView('/tablero/explorer-list-edit', _cParamsData)
    }


    else {
      _paramsData.p_date_exactly = this.fnFormatDate(_paramsData.p_date_exactly);
      _paramsData.p_date_init = this.fnFormatDate(_paramsData.p_date_init);
      _paramsData.p_date_end = this.fnFormatDate(_paramsData.p_date_end);
      this.paramsData = _paramsData;

      this.fnGoToView('/tablero/explorer-list-edit', _paramsData)
    }
  }


  fnSearchFarmerNames(farmer_name: string): string[] {
    const _optionList: string[] = [];
    const _var = {
      page: 0,
      page_size: 100,
      farmer_name: farmer_name,
      is_public: null
    };
    this.observationService.getFarmerNames(_var)
      .subscribe((_resp: any) => {
        _resp.data.map(
          (_element: string) => { _optionList.push(_element) });
      });
    return _optionList;
  }

  fnSearchVarietyNames(variety_value: string): string[] {
    const _optionList: string[] = [];

    const _var = {
      variety_name: variety_value,
      is_original: null,
      is_public: null,
      page: null,
      page_size: null,
    };

    this.observationService.getVarietyNames(_var)
      .subscribe((_resp: any) => {
        _resp.data.map(
          (_element: string) => { _optionList.push(_element) });
      });

    return _optionList;
  }

  handlePageEvent(event: PageEvent) {
    this.page_control = event.pageIndex;
    this.page_size_control = event.pageSize;
    this._length = event.length;
    this.fnSearchVarietyObservation("handlePageEvent");
  }

  fnOpenDialog(bt: any, _width: number): void {
    const _element = bt._elementRef.nativeElement;
    const _rect = _element
      ? _element.getBoundingClientRect()
      : { top: 0, left: 0 };

    const _dialogRef = this.dialog.open(DialogFilterComponent, {
      width: _width + "px",
      data: this.paramsData,
      position: {
        top: _rect.bottom + "px",
        left: _rect.right - _width + "px",
      },
    });

    _dialogRef.afterClosed().subscribe((_result: any) => {
      if (_result) {

        let _badgeFilters = 0;
        _badgeFilters = _badgeFilters + (_result.p_date_exactly ? 1 : 0);
        _badgeFilters = _badgeFilters + (_result.p_date_init ? 1 : 0);
        _badgeFilters = _badgeFilters + (_result.p_date_end ? 1 : 0);
        _badgeFilters = _badgeFilters + (_result.p_month ? 1 : 0);
        _badgeFilters = _badgeFilters + (_result.p_user_id ? 1 : 0);
        _badgeFilters = _badgeFilters + (_result.p_place ? 1 : 0);
        this.badgeFilter = _badgeFilters > 0 ? _badgeFilters : null;
        this.fnParamsDataChange(_result)

      }
    });
  }

  fnFormatDate(_date: any | null): string | null {
    try {
      return _date.toISOString().slice(0, 10).replace("T", " ");
    } catch (error) {
      return _date;
    }
  }


  fnGoToView(_route: string, _params: any | null) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([_route], {
        queryParams: _params
      }).then(() => {
      })
    })
  }

  fnIsRole(role: string) {
    return this.authService.isRole(role);
  }

  fnSync() {
    const _date_now = new Date();
    const _new_date = new Date(_date_now.setMinutes(_date_now.getMinutes() - 5));
    this.observationService.getSync({ start_date: _new_date.toISOString() }).subscribe(
      (_resp: any) => {
        const condition = _resp.success;
        if (condition) {
          this.fnGetStats();
        }
      }
    );
  }

  fnGetStats() {
    this.statsObs = this.observationService.getStats();
    this.statsObs.subscribe(
      (_resp: any) => {
        const condition = _resp.success;
        if (condition) {
          this.fnClearFilters();
        }
      }
    );
  }

  fnClearFilters() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/tablero/explorer-list-edit"]).then(() => {
      })
    })
  }


  fnGetAllCoordinates() {
    this.gpsCoordinateList = [];
    // para que se ve un componente con nuevos datos hay que dar tiempo ocultándolo
    const _req = {
      is_public: null
    }
    this.observationService.getGpsLocations(_req).subscribe(
      (_req) => {
        if (_req.success) {
          this.gpsCoordinateList = _req.data;
        }
      }
    );
  }
}